import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { ITrainingPhaseProfessionalSituationResource } from "../types";

const getResourcePath = (resource: RelationalValue<ITrainingPhaseProfessionalSituationResource>) =>
    typeof resource === "string" ? resource : resource["@id"];

export interface ITrainingPhaseProfessionalSituationUpdateMutationParameters {
    trainingPhaseProfessionalSituation: RelationalValue<ITrainingPhaseProfessionalSituationResource>;
    startHour: number;
    endHour: number;
    hasPlanningSuggestion: boolean;
}

export type ITrainingPhaseProfessionalSituationUpdateMutationResult = ITrainingPhaseProfessionalSituationResource;

export const trainingPhaseProfessionalSituationUpdateMutation: IApiMutationFunction<
    ITrainingPhaseProfessionalSituationUpdateMutationParameters
> = ({ trainingPhaseProfessionalSituation, startHour, endHour, hasPlanningSuggestion }) => {
    return {
        method: "PATCH",
        url: getResourcePath(trainingPhaseProfessionalSituation),
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
        data: {
            startHour,
            endHour,
            hasPlanningSuggestion,
        },
    };
};

export const useTrainingPhaseProfessionalSituationUpdateMutation = createApiMutationHook<
    ITrainingPhaseProfessionalSituationUpdateMutationParameters,
    ITrainingPhaseProfessionalSituationUpdateMutationResult
>(trainingPhaseProfessionalSituationUpdateMutation);
